export enum StripePaymentIntentStatusEnum {
  CANCELED = "canceled",
  PROCESSING = "processing",
  REQUIRES_ACTION = "requires_action",
  REQUIRES_CAPTURE = "requires_capture",
  REQUIRES_CONFIRMATION = "requires_confirmation",
  REQUIRES_PAYMENT_METHOD = "requires_payment_method",
  SUCCEEDED = "succeeded",
}
